/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { VetsInfo } from './vetsInfo.model';
import { OpeningHoursComponent } from './opening-hours/opening-hours.component';
import { Browser } from '@capacitor/browser';
import { ReviewsComponent } from './reviews/reviews.component';
import { PlacesApiService } from './vets.service';
declare let google;
@Component({
  selector: 'app-vets-near-by',
  templateUrl: './vets-near-by.page.html',
  styleUrls: ['./vets-near-by.page.scss'],
})
export class VetsNearByPage implements OnInit {
  isLocationSelected = false;
  isLoading = false;
  vetsDetails: VetsInfo[] = [];
  service: any;
  currentLocation: { lat: number; lng: number };
  showOpenNow = false;
  private latestRequestId = 0;

  constructor(
    private placesApi: PlacesApiService,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit() {
    this.isLoading = true;
  }
  findVets(event: any) {
    this.isLocationSelected = true;
    this.currentLocation = { lat: event.lat, lng: event.lng };
    this.loadVetsFromMaps(event.lat, event.lng);
  }

  async goToDirections(dest: { lat: number; lng: number }) {
    // eslint-disable-next-line max-len
    const directions = `https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=${this.currentLocation.lat},${this.currentLocation.lng}&destination=${dest.lat},${dest.lng}`;
    await Browser.open({ url: directions });
  }
  // callVet(phoneNumber: string) {
  //   this.callNumber.callNumber(phoneNumber, true);
  // }
  async goToWebsite(website: string) {
    await Browser.open({ url: website });
  }
  viewOpeningHours(vetInfo: VetsInfo) {
    this.modalCtrl
      .create({
        component: OpeningHoursComponent,
        componentProps: { vet: vetInfo },
      })
      .then((modalEl) => {
        modalEl.present();
      });
  }

  ReadReviews(vetInfo: VetsInfo) {
    this.modalCtrl
      .create({
        component: ReviewsComponent,
        componentProps: { vet: vetInfo },
      })
      .then((modalEl) => {
        modalEl.present();
      });
  }

  showOpenLocationsToggle() {
    this.vetsDetails = [];
    if (this.currentLocation) {
      this.findVets(this.currentLocation);
    }
  }

  private async loadVetsFromMaps(lat: number, lng: number) {
    this.latestRequestId++;
    const currentRequestId = this.latestRequestId;
    this.isLoading = true;
    this.vetsDetails = [];

    try {
      const nearby = await this.placesApi.nearbyVets(lat, lng, this.showOpenNow);
      for (let i = 0; i < nearby.length; i++) {
        if (currentRequestId !== this.latestRequestId) return;
        const d = await this.placesApi.vetDetails(nearby[i].placeId);

        const vet: VetsInfo = {
          vetId: d.vetId,
          name: d.name,
          openingHours: d.openingHours,
          reviews: d.reviews,
          phoneNumber: d.phoneNumber,
          rating: d.rating,
          ratingsTotal: d.ratingsTotal,
          website: d.website,
          location: { lat: d.lat, lng: d.lng },
          isOpen: d.isOpen
        };

        this.vetsDetails.push(vet);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    } catch (err) {
      this.alertCtrl.create({
        header: 'Could not fetch data',
        message: 'Please try again later or try a different location.',
        buttons: [{ text: 'Dismiss' }],
      }).then(a => a.present());
    } finally {
      this.isLoading = false;
    }
  }

}
